import type {
  CarsListSuccess,
} from '@autobid/strapi-integration/typescript/auction/carsList'
import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import {
  auctionCarsQueryKey,
} from '@autobid/ui/composables/car/data/useAuctionCars'
import { AUCTION_CARS_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useAuctionCarsSocket'
import { useQueryClient } from '@tanstack/vue-query'

export function useAuctionCarsAuctionResume() {
  const { startListen } = useWebSocketStore()
  const queryClient = useQueryClient()

  const auctionResume = () => {
    startListen({
      eventName: 'premium.AUCTION_RESUME',
      callbackName: AUCTION_CARS_SOCKET_CALLBACK,
      callback: (event) => {
        const { auctionId, resumeTime } = event.context
        const queryKey = auctionCarsQueryKey.byAuctionId(auctionId)

        queryClient.setQueriesData(
          queryKey,
          (
            data?: CarsListSuccess['data']['items'],
          ): CarsListSuccess['data']['items'] | undefined => {
            if (!data)
              return data

            return {
              ...data,
              items: data.items.map((item) => {
                if (item.stage !== 'IN_AUCTION')
                  return item

                const newTime = new Date(resumeTime * 1000).toISOString()

                return {
                  ...item,
                  pausedHotbidStartTime: null,
                  auctionStartDate: newTime,
                  hotbidStartTime: newTime,
                }
              }),
            }
          },
        )
      },
    })
  }

  return { auctionResume }
}
